import React, { FC, useCallback, SyntheticEvent } from 'react'
import Link, { LinkProps as NextLinkProps } from 'next/link'
import { ImageProps } from 'next/image'
import DOMPurify from 'isomorphic-dompurify'

import { IconName, IconProps } from '../Icon'

import * as SC from './styled'

export type LinkProps = Omit<Partial<NextLinkProps>, 'as'> & {
  className?: string
  target?: string
  title?: string
  role?: string
  dangerousInsert?: boolean
  tabIndex?: number
  rel?: string
  onClickHandler?: (ev?: SyntheticEvent) => void
  nextAs?: string
  label?: string
}
export type TextLinkProps =
  | (LinkProps & { text: string; icon?: IconName })
  | null
export type PictoLinkProps = {
  iconProps: IconProps
  linkProps: TextLinkProps | null
}
export type ImageLinkProps = {
  imageProps: ImageProps
  linkProps: LinkProps | null
}

// eslint-disable-next-line react/display-name
const A: FC<LinkProps> = (props) => {
  const {
    className,
    children,
    href,
    prefetch,
    replace,
    scroll,
    shallow,
    dangerousInsert,
    locale,
    target,
    title,
    role,
    tabIndex,
    rel,
    onClickHandler,
    nextAs,
    label,
  } = props

  const handleClick = useCallback(
    (ev) => {
      onClickHandler?.(ev)
    },
    [onClickHandler]
  )

  return (
    <>
      {href && (
        <Link
          href={href}
          passHref
          {...(nextAs && { as: nextAs })}
          {...(prefetch && { prefetch })}
          {...(replace && { replace })}
          {...(scroll && { scroll })}
          {...(shallow && { shallow })}
          {...(locale && { locale })}
        >
          <SC.Link
            className={`${className} is-link`}
            {...(target && { target })}
            {...(title && { title })}
            {...(role && { role })}
            {...(tabIndex && { tabIndex })}
            {...(rel && { rel })}
            {...(onClickHandler && { onClick: handleClick })}
          >
            {children}
          </SC.Link>
        </Link>
      )}
      {!href && onClickHandler && (
        <SC.Button
          className={`${className} is-button`}
          {...{ onClick: handleClick }}
          {...(label && { 'aria-label': label })}
        >
          {children}
        </SC.Button>
      )}
      {!href && !onClickHandler && !dangerousInsert && (
        <SC.Span className={`${className} is-span`}>{children}</SC.Span>
      )}
      {!href && !onClickHandler && dangerousInsert && (
        <SC.Span
          className={`${className} is-span`}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(children!.toString()),
          }}
        ></SC.Span>
      )}
    </>
  )
}

export default A
